import { apolloProvider } from "../../vue-apollo";
import {
  getActividadesEconomicas,
  getDepartamentos,
  getDistritos,
  getMunicipios,
} from "@/api/catalogs";
const apolloClient = apolloProvider.defaultClient;

const state = () => ({
  actividadesEconomicas: [],
  actividadesEconomicasLoading: false,
  departamentos: [],
  departamentosLoading: false,
  municipios: [],
  municipiosLoading: false,
  distritos: [],
  distritosLoading: false,
});

// getters
const getters = {};

const actions = {
  getActividadesEconomicas({ commit }, { data }) {
    commit("setLoadingActividadesEconomicas", true);
    apolloClient
      .query({ query: getActividadesEconomicas, variables: data })
      .then(({ data }) => {
        commit("setActividadesEconomicas", data.getActividadesEconomicas);
      })
      .catch((error) => {
        console.error(error);
        commit("setLoadingActividadesEconomicas", false);
      });
  },

  getDepartamentos({ commit }, { data }) {
    commit("setLoadingDepartamentos", true);
    apolloClient
      .query({ query: getDepartamentos, variables: data })
      .then(({ data }) => {
        commit("setDepartamentos", data.getDepartamentos);
        commit("setMunicipios", []);
        commit("setDistritos", []);
      })
      .catch((error) => {
        console.error(error);
        commit("setLoadingDepartamentos", false);
      });
  },

  getMunicipios({ commit }, { data }) {
    commit("setLoadingMunicipios", true);
    apolloClient
      .query({ query: getMunicipios, variables: data })
      .then(({ data }) => {
        commit("setMunicipios", data.getMunicipios);
        commit("setDistritos", []);
      })
      .catch((error) => {
        console.error(error);
        commit("setLoadingMunicipios", false);
      });
  },

  getDistritos({ commit }, { data }) {
    commit("setLoadingDistritos", true);
    apolloClient
      .query({ query: getDistritos, variables: data })
      .then(({ data }) => {
        commit("setDistritos", data.getDistritos);
      })
      .catch((error) => {
        console.error(error);
        commit("setLoadingDistritos", false);
      });
  },
};

// mutations
const mutations = {
  setLoadingActividadesEconomicas(state, loading) {
    state.actividadesEconomicasLoading = loading;
  },
  setActividadesEconomicas(state, actividadesEconomicas) {
    state.actividadesEconomicasLoading = false;
    state.actividadesEconomicas = actividadesEconomicas;
  },

  setLoadingDepartamentos(state, loading) {
    state.departamentosLoading = loading;
  },
  setDepartamentos(state, departamentos) {
    state.departamentosLoading = false;
    state.departamentos = departamentos;
  },

  setLoadingMunicipios(state, loading) {
    state.municipiosLoading = loading;
  },
  setMunicipios(state, municipios) {
    state.municipiosLoading = false;
    state.municipios = municipios;
  },

  setLoadingDistritos(state, loading) {
    state.distritosLoading = loading;
  },
  setDistritos(state, distritos) {
    state.distritosLoading = false;
    state.distritos = distritos;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
